@if (!isAggregate) {
  <div class="d-flex align-items-center">
    <ng-select
      i18n-placeholder
      placeholder="Please select..."
      bindValue="value"
      bindLabel="label"
      class="form-control"
      [ngModel]="cellData"
      (change)="onChange($event)"
      [items]="params.context.options | async"
    ></ng-select>
  </div>
}
